const releasesValidationIT = {
    "add": {
        "releaseName": {
            "required": 'Il nome della release è obbligatorio',
            "length": 'Il nome della release deve essere più lungo di 2 e meno di 120 caratteri',
            "noForwardSlash": 'Il nome della release non deve contenere alcuna barra (/) avanti',
            "matchTrack": 'Per una release di una canzone, il nome della release deve corrispondere al brano.',
            // validCharacters: 'Il nome della release può consistere solo di caratteri alfabetici, numeri, spazi e underscore'},
        },
        "releaseVersion": {
                "length": 'La versione della release deve essere più lunga di 2 e meno di 120 caratteri',
                "validCharacters": 'La versione della release può consistere solo di caratteri alfabetici, numeri, spazi e underscore',
                "missingOne": 'La tua release consiste di un solo brano che non è un Original Mix, quindi il nome del mix personalizzato deve essere inserito nella versione della release.',
                "missingTwo": 'Se una release offre più contenuti rispetto alla versione standard o è un\'altra versione di un album / release già pubblicato, devi inserire la versione della release.',
                "invalid": 'Per una release di una canzone senza nome del mix (Original Mix), la versione della release dovrebbe essere lasciata vuota. Si prega di cancellare la versione della release o aggiungere un nome del mix alla canzone.'
            },
            "releaseLanguage": {
                "required": 'La lingua della release è obbligatoria. Si prega di selezionare la lingua del nome della release.'
            },
            "releaseEAN_UPC": {
                "required": "EAN / UPC è obbligatorio.",
                "length": "Il numero EAN deve essere lungo esattamente 13 caratteri.",
                "isValidEAN": "Il valore non è un EAN valido. Se stai inserendo una nuova pubblicazione, inserisci un EAN corretto. Se stai caricando un catalogo precedente e l’EAN non è valido, contattaci."
            },
            "releaseLabel": {
                "required": 'Si prega di selezionare la tua etichetta.'
            },
            "releaseCopyright": {
                "required": 'Devi digitare il proprietario del copyright. Di solito è la tua etichetta.'
            },
            "releaseCopyrightYear": {
                "required": 'Si prega di digitare l\'anno di copyright in cui questa release sarà (è stata) pubblicata.',
                "regexp": 'Si prega di digitare un anno di copyright valido'
            },
            "releaseCopyrightPublisher": {
                "required": 'Devi digitare il proprietario dell\'editore. Di solito è la tua etichetta.'
            },
            "releaseCopyrightYearPublisher": {
                "required": 'Si prega di digitare l\'anno di copyright in cui questa release sarà (è stata) pubblicata.',
                "regexp": 'Si prega di digitare un anno di copyright valido'
            },
            "releaseGenre": {
                "required": 'Si prega di selezionare il genere della tua release.'
            },
            "releaseSubGenre": {
                "required": 'Si prega di selezionare il sottogenere della tua release'
            },
            "releaseCatalogNumber": {
                "required": 'Inserisci un numero di catalogo unico per la release.',
                "length": 'Minimo 4 e massimo 16 caratteri.',
                "validFormat": 'Si prega di inserire il numero di categoria senza spazi, solo lettere MAIUSCOLE e numeri. I primi due caratteri devono essere lettere MAIUSCOLE. MM001, MMD001, MM0001 ... '
            },
            "releaseDescription": {
                // required: 'Una buona e professionale descrizione della release può fare la differenza.',
                "length": 'Una descrizione della release deve essere di almeno 100 e massimo 600 caratteri.'
            },
            "releaseArtwork": {
                "required": 'L\'artwork è obbligatorio',
                "wrongSpecsAndColor": 'Specifiche e formato colore dell\'immagine errati. La dimensione della copertina della release deve essere esattamente 3000 x 3000 px, colori RGB, JPG, dimensione massima del file 4 MB.',
                "wrongColorFormat": 'Formato colore dell\'immagine errato. La copertina della release deve essere in colori RGB. JPG, dimensione massima del file 4 MB.',
                "wrongSpecs": 'Specifiche dell\'immagine errate. La dimensione della copertina della release deve essere esattamente 3000 x 3000 px. JPG, dimensione massima del file 4 MB.',
                "meetsSpecs": 'L\'immagine soddisfa tutte le specifiche.',
                "chooseImage": 'Si prega di scegliere un\'immagine',
                "fileTooLarge": 'Il file selezionato è più grande di 4 MB. Si prega di caricare la copertina in 3000x3000 px, JPG, colori RGB, dimensione massima del file 4 MB',
                "wrongExtension": 'Estensione del file errata. Il file selezionato ha estensione ".jpeg". Si prega di caricare la copertina in 3000x3000 px, JPG (solo estensione ".jpg"), colori RGB, dimensione massima del file 4 MB'
            },
            "releaseTerritories": {
                "required": 'Si prega di selezionare i territori.'
            },
            "atleastOneCountrySelected": {
                "required": 'Si prega di selezionare almeno un paese.'
            },
            "atleastOneContentIDChoiceSelected": {
                "required": 'La dichiarazione del Content ID di Youtube è obbligatoria, si prega di selezionare una delle opzioni sopra.'
            },
            "originalReleaseDate": {
                "required": 'Si prega di selezionare la data di rilascio originale per tutti i negozi nel mondo.'
            },
            "officialReleaseDate": {
                "required": 'Si prega di selezionare la data di rilascio ufficiale per tutti i negozi nel mondo.'
            },
            "atleastOneMainArtist": {
                "required": 'Almeno un artista deve essere principale'
            },
            "featuringArtistMissing": {
                "required": 'La release deve avere l\'artista in evidenza elencato nel titolo correttamente assegnato al ruolo di artista in evidenza. Si prega di modificare e inviare nuovamente.'
            },
            "duplicateArtists": {
                "required": 'Ci sono due o più artisti con lo stesso nome.'
            },
            "artistName": {
                "required": 'Si prega di selezionare l\'artista'
            },
            "artistType": {
                "required": 'Si prega di selezionare il tipo di artista'
            },
            "trackName": {
                "required": 'Si prega di digitare il nome del brano'
            },
            "trackMixName": {
                "required": 'Si prega di digitare il nome del mix',
                "regexp": 'Il nome del mix può consistere solo di caratteri alfabetici, numeri, spazi e underscore'
            }
    },
    "update": {
        "releaseName": {
            "required": 'Il nome della release è obbligatorio',
            "length": 'Il nome della release deve essere più lungo di 2 e meno di 120 caratteri',
            "noForwardSlash": 'Il nome della release non deve contenere alcuna barra (/) avanti',
            "matchTrack": 'Per una release di una canzone, il nome della release deve corrispondere al brano.',
            "validCharacters": 'Il nome della release può consistere solo di caratteri alfabetici, numeri, spazi e underscore'
        },
        "releaseVersion": {
            "length": 'La versione della release deve essere più lunga di 2 e meno di 120 caratteri',
            "validCharacters": 'La versione della release può consistere solo di caratteri alfabetici, numeri, spazi e underscore',
            "missingOne": 'La tua release consiste di un solo brano che non è un Original Mix, quindi il nome del mix personalizzato deve essere inserito nella versione della release.',
            "missingTwo": 'Se una release offre più contenuti rispetto alla versione standard o è un\'altra versione di un album / release già pubblicato, devi inserire la versione della release.',
            "invalid": 'Per una release di una canzone senza nome del mix (Original Mix), la versione della release dovrebbe essere lasciata vuota. Si prega di cancellare la versione della release o aggiungere un nome del mix alla canzone.'
        },
        "releaseLanguage": {
            "required": 'La lingua della release è obbligatoria. Si prega di selezionare la lingua del nome della release.'
        },
        "releaseEAN_UPC": {
            "required": "EAN / UPC è obbligatorio.",
            "length": "Il numero EAN deve essere lungo esattamente 13 caratteri.",
            "isValidEAN": "Il valore non è un EAN valido. Se stai inserendo una nuova pubblicazione, inserisci un EAN corretto. Se stai caricando un catalogo precedente e l’EAN non è valido, contattaci."
        },
        "releaseLabel": {
            "required": 'Si prega di selezionare la tua etichetta.'
        },
        "releaseCopyright": {
            "required": 'Devi selezionare il proprietario del copyright. Di solito è la tua etichetta.'
        },
        "releaseCopyrightYear": {
            "required": 'Si prega di digitare l\'anno di copyright in cui questa release sarà (è stata) pubblicata.',
            "regexp": 'Si prega di digitare un anno di copyright valido'
        },
        "releaseCopyrightPublisher": {
            "required": 'Devi digitare il proprietario dell\'editore. Di solito è la tua etichetta.'
        },
        "releaseCopyrightYearPublisher": {
            "required": 'Si prega di digitare l\'anno di copyright in cui questa release sarà (è stata) pubblicata.',
            "regexp": 'Si prega di digitare un anno di copyright valido'
        },
        "releaseGenre": {
            "required": 'Si prega di selezionare il genere della tua release.'
        },
        "releaseSubGenre": {
            "required": 'Si prega di selezionare il sottogenere della tua release'
        },
        "releaseCatalogNumber": {
            "required": 'Inserisci un numero di catalogo unico per la release.',
            "length": 'Minimo 4 e massimo 16 caratteri.',
            "validFormat": 'Si prega di inserire il numero di categoria senza spazi, solo lettere MAIUSCOLE e numeri. I primi due caratteri devono essere lettere MAIUSCOLE. MM001, MMD001, MM0001 ...'
        },
        "releaseDescription": {
            "length": 'Una descrizione della release deve essere di almeno 100 e massimo 600 caratteri.'
        },
        "releaseArtwork": {
            "required": 'L\'artwork è obbligatorio',
            "wrongSpecsAndColor": 'Specifiche e formato colore dell\'immagine errati. La dimensione della copertina della release deve essere esattamente 3000 x 3000 px, colori RGB, JPG, dimensione massima del file 4 MB.',
            "wrongColorFormat": 'Formato colore dell\'immagine errato. La copertina della release deve essere in colori RGB. JPG, dimensione massima del file 4 MB.',
            "wrongSpecs": 'Specifiche dell\'immagine errate. La dimensione della copertina della release deve essere esattamente 3000 x 3000 px. JPG, dimensione massima del file 4 MB.',
            "meetsSpecs": 'L\'immagine soddisfa tutte le specifiche.',
            "chooseImage": 'Si prega di scegliere un\'immagine',
            "fileTooLarge": 'Il file selezionato è più grande di 4 MB. Si prega di caricare la copertina in 3000x3000 px, JPG, colori RGB, dimensione massima del file 4 MB',
            "wrongExtension": 'Estensione del file errata. Il file selezionato ha estensione ".jpeg". Si prega di caricare la copertina in 3000x3000 px, JPG (solo estensione ".jpg"), colori RGB, dimensione massima del file 4 MB'
        },
        "releaseTerritories": {
            "required": 'Si prega di selezionare i territori.'
        },
        "atleastOneCountrySelected": {
            "required": 'Si prega di selezionare almeno un paese.'
        },
        "atleastOneContentIDChoiceSelected": {
            "required": 'La dichiarazione del Content ID di Youtube è obbligatoria, si prega di selezionare una delle opzioni sopra.'
        },
        "originalReleaseDate": {
            "required": 'Si prega di selezionare la data di rilascio originale per tutti i negozi nel mondo.'
        },
        "officialReleaseDate": {
            "required": 'Si prega di selezionare la data di rilascio ufficiale per tutti i negozi nel mondo.'
        },
        "atleastOneMainArtist": {
            "required": 'Almeno un artista deve essere principale'
        },
        "featuringArtistMissing": {
            "required": 'La release deve avere l\'artista in evidenza elencato nel titolo correttamente assegnato al ruolo di artista in evidenza. Si prega di modificare e inviare nuovamente.'
        },
        "duplicateArtists": {
            "required": 'Ci sono due o più artisti con lo stesso nome.'
        },
        "artistName": {
            "required": 'Si prega di selezionare l\'artista'
        },
        "artistType": {
            "required": 'Si prega di selezionare il tipo di artista'
        },
        "trackName": {
            "required": 'Si prega di digitare il nome del brano'
        },
        "trackMixName": {
            "required": 'Si prega di digitare il nome del mix',
            "regexp": 'Il nome del mix può consistere solo di caratteri alfabetici, numeri, spazi e underscore'
        }
    },
    "transfer": {
        "releaseName": {
            "required": "Il nome della release è obbligatorio",
            "length": "Il nome della release deve essere tra 2 e 120 caratteri",
            "invalid": "Il nome della release non può contenere una barra (/) avanti"
        },
        "releaseVersion": {
            "length": "La versione della release deve essere più lunga di 2 e meno di 120 caratteri",
            "regexp": "La versione della release può consistere solo di caratteri alfabetici, numeri, spazi e underscore",
            "missingOne": "La tua release consiste di un solo brano che non è un Original Mix, quindi il nome del mix personalizzato deve essere inserito nella versione della release.",
            "missingTwo": "Se una release offre più contenuti rispetto alla versione standard o è un'altra versione di un album/release già pubblicato, devi inserire la versione della release.",
            "invalid": "Per una release di una canzone senza nome del mix (Original Mix), la versione della release dovrebbe essere lasciata vuota. Si prega di cancellare la versione della release o aggiungere un nome del mix alla canzone."
        },
        "releaseLanguage": {
            "required": "La lingua della release è obbligatoria. Si prega di selezionare la lingua del nome della release."
        },
        "releaseLabel": {
            "required": "Si prega di selezionare la tua etichetta."
        },
        "releaseCopyright": {
            "required": "Devi digitare il proprietario del copyright. Di solito è la tua etichetta."
        },
        "releaseCopyrightYear": {
            "required": "Si prega di digitare l'anno di copyright in cui questa release sarà (è stata) pubblicata.",
            "regexp": "Si prega di digitare un anno di copyright valido"
        },
        "releaseCopyrightPublisher": {
            "required": "Devi digitare il proprietario dell'editore. Di solito è la tua etichetta."
        },
        "releaseCopyrightYearPublisher": {
            "required": "Si prega di digitare l'anno di copyright in cui questa release sarà (è stata) pubblicata.",
            "regexp": "Si prega di digitare un anno di copyright valido"
        },
        "releaseGenre": {
            "required": "Si prega di selezionare il genere della tua release."
        },
        "releaseSubGenre": {
            "required": "Si prega di selezionare il sottogenere della tua release."
        },
        "releaseCatalogNumber": {
            "required": "Inserisci un numero di catalogo unico per la release.",
            "length": "Minimo 4 e massimo 16 caratteri.",
            "regexp": "Si prega di inserire il numero di categoria senza spazi, solo lettere MAIUSCOLE e numeri. I primi due caratteri devono essere lettere MAIUSCOLE. MM001, MMD001, MM0001 ... "
        },
        "releaseDescription": {
            "length": "Una descrizione della release deve essere di almeno 100 e massimo 600 caratteri."
        },
        "releaseArtwork": {
            "required": "L'artwork è obbligatorio",
            "invalidDimensionsAndColorFormat": "Specifiche e formato colore dell'immagine errati. La dimensione della copertina della release deve essere esattamente 3000 x 3000 px, colori RGB, JPG, dimensione massima del file 4 MB.",
            "invalidColorFormat": "Formato colore dell'immagine errato. La copertina della release deve essere in colori RGB. JPG, dimensione massima del file 4 MB.",
            "invalidDimensions": "Specifiche dell'immagine errate. La dimensione della copertina della release deve essere esattamente 3000 x 3000 px. JPG, dimensione massima del file 4 MB.",
            "valid": "L'immagine soddisfa tutte le specifiche",
            "choose": "Si prega di scegliere un'immagine",
            "fileSize": "Il file selezionato è più grande di 4 MB. Si prega di caricare la copertina in 3000x3000 px, JPG, colori RGB, dimensione massima del file 4 MB",
            "fileExtension": "Estensione del file errata. Il file selezionato ha estensione '.jpeg'. Si prega di caricare la copertina in 3000x3000 px, JPG (solo estensione '.jpg'), colori RGB, dimensione massima del file 4 MB'"
        },
        "releaseTerritories": {
            "required": "Si prega di selezionare i territori."
        },
        "atleastOneCountrySelected": {
            "required": "Si prega di selezionare almeno un paese."
        },
        "atleastOneContentIDChoiceSelected": {
            "required": "La dichiarazione del Content ID di Youtube è obbligatoria, si prega di selezionare una delle opzioni sopra."
        },
        "originalReleaseDate": {
            "required": "Si prega di selezionare la data di rilascio originale per tutti i negozi nel mondo."
        },
        "officialReleaseDate": {
            "required": "Si prega di selezionare la data di rilascio ufficiale per tutti i negozi nel mondo."
        },
        "atleastOneMainArtist": {
            "required": "Almeno un artista deve essere principale"
        },
        "artistType": {
            "required": "Si prega di selezionare il tipo di artista"
        },
        "trackName": {
            "required": "Si prega di digitare il nome del brano"
        },
        "trackMixName": {
            "required": "Si prega di digitare il nome del mix",
            "regexp": "Il nome del mix può consistere solo di caratteri alfabetici, numeri, spazi e underscore"
        }
    }
};

export default releasesValidationIT;